'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRACK_EVENT = exports.TRACK_EVENT = '@@hublytics';